/*
 * Az değişen tanım listeleri için bellek içi istek önbelleği (randevu türleri, durumlar, kurumlar, onay ayarı).
 * - Aynı anahtarla eşzamanlı çağrılar tek isteğe iner (ör. aynı ekranda iki bileşen).
 * - Başarılı yanıt TTL boyunca tekrar kullanılır; başarısız yanıt saklanmaz.
 * - Her çağırana kopya döner: bir bileşenin res.data'yı değiştirmesi önbelleği bozmaz.
 * - İlgili kayıt/silme istekleri ApiService içinde invalidateApiCache(prefix) çağırır;
 *   oturum değişince (giriş/çıkış) clearApiCache() — liste kullanıcının firma yetkisine göre süzülüyor.
 */

const DEFAULT_TTL_MS = 5 * 60 * 1000

const store = new Map()

const clone = (res) => {
    try {
        return structuredClone(res)
    } catch {
        return JSON.parse(JSON.stringify(res))
    }
}

export function cachedRequest(key, request, ttlMs = DEFAULT_TTL_MS) {
    const hit = store.get(key)
    if (hit && hit.expires > Date.now())
        return hit.promise.then(clone)

    const promise = request().then(res => {
        if (!res?.success && store.get(key)?.promise === promise)
            store.delete(key)
        return res
    }, err => {
        if (store.get(key)?.promise === promise)
            store.delete(key)
        throw err
    })

    store.set(key, { promise, expires: Date.now() + ttlMs })
    return promise.then(clone)
}

export function invalidateApiCache(prefix) {
    for (const key of Array.from(store.keys())) {
        if (key.startsWith(prefix)) store.delete(key)
    }
}

export function clearApiCache() {
    store.clear()
}

/** Kayıt isteğinin sonucunu değiştirmeden ilgili önbelleği temizler. */
export const invalidatesApiCache = (prefix) => (res) => {
    invalidateApiCache(prefix)
    return res
}
